import React from 'react';
import Button from '@material-ui/core/Button';
import { useTheme } from '@material-ui/styles';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, useMediaQuery } from '@material-ui/core';

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import { BodyParent, BodyChildren } from './animation/variants';

const useStyles = makeStyles((theme) => ({
  sponsorsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '50px',
  },
  diamond: {
    [theme.breakpoints.down('sm')]: {
      width: '400px',
      height: '100%',
    },
    [theme.breakpoints.up('md')]: {
      width: '750px',
      height: '100%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '1050px',
      height: '100%',
    },
  },
  gold: {
    [theme.breakpoints.down('sm')]: {
      width: '85px',
      height: '100%',
    },
    [theme.breakpoints.up('md')]: {
      width: '140px',
      height: '100%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '180px',
      height: '100%',
    },
  },
  sunlifeLogo: {
    [theme.breakpoints.down('sm')]: {
      width: '180px',
      height: '100%',
    },
    [theme.breakpoints.up('md')]: {
      width: '300px',
      height: '100%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '400px',
      height: '100%',
    },
  },
  silver: {
    [theme.breakpoints.down('sm')]: {
      width: '140px',
      height: '100%',
    },
    [theme.breakpoints.up('md')]: {
      width: '250px',
      height: '100%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '300px',
      height: '100%',
    },
  },
  eyLogo: {
    [theme.breakpoints.down('sm')]: {
      width: '60px',
      height: '100%',
      paddingLeft: '15px',
      paddingRight: '15px',
    },
    [theme.breakpoints.up('md')]: {
      width: '125px',
      height: '100%',
      paddingLeft: '35px',
      paddingRight: '35px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '150px',
      height: '100%',
      paddingLeft: '35px',
      paddingRight: '35px',
    },
  },
  bronze: {
    [theme.breakpoints.down('sm')]: {
      width: '80px',
      height: '100%',
    },
    [theme.breakpoints.up('md')]: {
      width: '150px',
      height: '100%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '175px',
      height: '100%',
    },
  },
  pinnacleLogo: {
    [theme.breakpoints.down('sm')]: {
      width: '50px',
      height: '100%',
    },
    [theme.breakpoints.up('md')]: {
      width: '80px',
      height: '100%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '100px',
      height: '100%',
    },
  },
  inKind: {
    [theme.breakpoints.down('sm')]: {
      width: '70px',
      height: '100%',
    },
    [theme.breakpoints.up('md')]: {
      width: '140px',
      height: '100%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '160px',
      height: '100%',
    },
  },
  sponsorsTitle: {
    color: 'black',
    textAlign: 'center',
    letterSpacing: '-0.04em',
  },
  hexGroupLeftWrapper: {
    width: '10px',
    height: '10px',
    marginRight: '-1125px',
  },
  hexGroupLeft: {
    width: '440px',
    height: '480px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: '150px',
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: '200px',
    },
  },
  hexGroupRightWrapper: {
    width: '10px',
    height: '10px',
    marginLeft: '-2000px',
  },
  hexGroupRight: {
    width: '440px',
    height: '480px',
    transform: 'rotate(13.6deg)',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: '150px',
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: '1100px',
    },
  },
}));

const Sponsors = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), {
    defaultMatches: true,
  });

  return (
    <motion.div>
      <div className={classes.sponsorsWrapper}>
        <Typography
          variant="h1"
          className={classes.sponsorsTitle}
          style={{ paddingBottom: '10px' }}>
          Thank you to all our Sponsors!
        </Typography>
        <div className={classes.hexGroupLeftWrapper}>
          <img
            src={require('./assets/hex-group.png')}
            alt="hex-group-left"
            className={classes.hexGroupLeft}
          />
        </div>
        <div className={classes.hexGroupRightWrapper}>
          <img
            src={require('./assets/hex-group.png')}
            alt="hex-group-right"
            className={classes.hexGroupRight}
          />
        </div>
        <Grid
          container
          direction="column"
          alignItems="center"
          justify="center"
          spacing={5}>
          <Grid item>
            <a href="https://scotiabank.com" target="#">
              <img
                className={classes.diamond}
                src={require('./assets/sponsorLogos/scotiabank.png')}
                alt="scotiabank"
                xl={12}
                l={12}
              />
            </a>
          </Grid>

          <Grid
            container
            item
            alignItems="center"
            justify="center"
            spacing={isMobile ? 5 : 10}>
            <Grid item>
              <a href="https://london.ca" target="#">
                <img
                  className={classes.gold}
                  src={require('./assets/sponsorLogos/londonCanada.png')}
                  alt="londonCanada"
                  xl={6}
                  l={6}
                />
              </a>
            </Grid>
            <Grid item>
              <a href="https://www.rbc.com/about-rbc.html" target="#">
                <img
                  className={classes.gold}
                  src={require('./assets/sponsorLogos/rbc.png')}
                  alt="rbc"
                  xl={6}
                  l={6}
                />
              </a>
            </Grid>
          </Grid>

          <Grid container item alignItems="center" justify="center">
            <Grid item>
              <a href="https://www2.deloitte.com/ca/en.html" target="#">
                <img
                  className={classes.silver}
                  src={require('./assets/sponsorLogos/deloitte.png')}
                  alt="deloitte"
                  xl={3}
                  l={3}
                />
              </a>
            </Grid>
            <Grid item>
              <a href="https://volleythat.com" target="#">
                <img
                  className={classes.silver}
                  src={require('./assets/sponsorLogos/volley.png')}
                  alt="volley"
                  xl={3}
                  l={3}
                />
              </a>
            </Grid>
            <Grid item>
              <a href="https://www.canada.ca/en/revenue-agency.html" target="#">
                <img
                  className={classes.silver}
                  src={require('./assets/sponsorLogos/cra.png')}
                  alt="cra"
                  xl={3}
                  l={3}
                />
              </a>
            </Grid>
          </Grid>
          <Grid container item alignItems="center" justify="center">
            <Grid item>
              <a href="https://www.sanofi.ca/" target="#">
                <img
                  className={classes.silver}
                  src={require('./assets/sponsorLogos/sanofi.png')}
                  alt="sanofi"
                  xl={3}
                  l={3}
                />
              </a>
            </Grid>
            <Grid item>
              <a href="http://www.futurfund.org/" target="#">
                <img
                  className={classes.silver}
                  src={require('./assets/sponsorLogos/futurfund.png')}
                  alt="futurfund"
                  xl={3}
                  l={3}
                />
              </a>
            </Grid>
            <Grid item>
              <a href="https://www.telus.com/en/" target="#">
                <img
                  className={classes.silver}
                  src={require('./assets/sponsorLogos/telus.png')}
                  alt="telus"
                  xl={3}
                  l={3}
                />
              </a>
            </Grid>
            <Grid item>
              <a href="https://www.cppinvestments.com/" target="#">
                <img
                  className={classes.silver}
                  src={require('./assets/sponsorLogos/cppinvestments.png')}
                  alt="CPP Investments"
                  xl={3}
                  l={3}
                />
              </a>
            </Grid>
          </Grid>

          <Grid container item alignItems="center" justify="center" spacing={5}>
            <Grid item>
              <a href="https://www.ey.com/en_ca" target="#">
                <img
                  className={classes.eyLogo}
                  src={require('./assets/sponsorLogos/EY.png')}
                  alt="ey"
                  xl={4}
                  l={4}
                />
              </a>
            </Grid>
            <Grid item>
              <a href="https://www.honeybadger.io/" target="#">
                <img
                  className={classes.bronze}
                  src={require('./assets/sponsorLogos/honeybadger.png')}
                  alt="honeybadger"
                  xl={4}
                  l={4}
                />
              </a>
            </Grid>
            <Grid item>
              <a href="https://www.fdmgroup.com/en-ca/ca-home/" target="#">
                <img
                  className={classes.bronze}
                  src={require('./assets/sponsorLogos/fdm.png')}
                  alt="fdm"
                  xl={4}
                  l={4}
                />
              </a>
            </Grid>
          </Grid>
          <Grid container item alignItems="center" justify="center" spacing={5}>
            <Grid item>
              <a href="https://www.imc.com/us/" target="#">
                <img
                  className={classes.bronze}
                  src={require('./assets/sponsorLogos/IMC.png')}
                  alt="imc"
                  xl={4}
                  l={4}
                />
              </a>
            </Grid>
            <Grid item>
              <a href="https://kuzoclass.com/" target="#">
                <img
                  className={classes.bronze}
                  src={require('./assets/sponsorLogos/kuzo.png')}
                  alt="kuzo"
                  xl={4}
                  l={4}
                />
              </a>
            </Grid>
            <Grid item>
              <a href="https://www.jonar.com/" target="#">
                <img
                  className={classes.bronze}
                  src={require('./assets/sponsorLogos/jonar.png')}
                  alt="jonar"
                  xl={4}
                  l={4}
                />
              </a>
            </Grid>
          </Grid>

          <Grid container item alignItems="center" justify="center" spacing={5}>
            <Grid item>
              <a href="http://hackp.ac/mlh-stickermule-hackathons" target="#">
                <img
                  className={classes.inKind}
                  src={require('./assets/sponsorLogos/stickermule.png')}
                  alt="stickermule"
                  xl={4}
                  l={4}
                />
              </a>
            </Grid>
            <Grid item>
              <a href="https://pinnacle.us.org/" target="#">
                <img
                  className={classes.pinnacleLogo}
                  src={require('./assets/sponsorLogos/pinnacle.png')}
                  alt="pinnacle"
                  xl={4}
                  l={4}
                />
              </a>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </motion.div>
  );
};

export default Sponsors;
